module.exports = __webpack_public_path__ + "static/media/23-8.53299861.mp3";